import React from 'react';
import PropTypes from 'prop-types';
import TaxFlowChartButton from './TaxFlowChartButton';
import TaxFlowChartSectionThreeResult from './TaxFlowChartSectionThreeResult';

const TaxFlowChartSectionThree = (props) => {
  const activeRowClass = props.section === 2 ? 'active' : '';
  const maxQBI = props.isSingle ? '$157,500' : '$317,000';
  const filingPipeClass = props.isSingle ? '' : 'filing-jointly-pipe';
  let yesButtonOffset = 'col-sm-offset-7';
  let noButtonOffset = 'col-sm-offset-7';
  let yesButtonActive = '';
  let noButtonActive = '';
  if (props.section > 2) {
    yesButtonOffset = props.validQBI ? 'active' : 'col-sm-offset-2';
    noButtonOffset = !props.validQBI ? 'active' : 'col-sm-offset-3';
    yesButtonActive = props.validQBI ? 'active' : '';
    noButtonActive = props.validQBI ? '' : 'active';
  }
  return (
    <React.Fragment>
      <div className={`row tax-flow-chart-question-three ${activeRowClass}`}>
        <div className="col-xs-12 visible-xs">
          <img src={`${props.cdnURL}/images/TaxFlowChart/question3-2x.png`} alt="Piggy Bank" />
          <p> Is your QBI less than {maxQBI} per year? </p>
        </div>
        <div className={`col-sm-2 col-sm-offset-9 hidden-xs tax-flow-chart-pipe ${filingPipeClass}`}>
          {props.section === 2 &&
            <img src={props.iconSrc} alt="User Icon" />
          }
          <p className="tax-flow-chart-overflow-text"> Is your QBI less than {maxQBI} per year? </p>
        </div>
      </div>
      <div className="row tax-flow-chart-button-row">
        <TaxFlowChartButton
          colClasses="col-xs-6 tax-flow-chart-button-col-left visible-xs"
          buttonClasses={`tax-flow-chart-button ${yesButtonActive}`}
          onClick={() => props.setQBI(true)}
          text="Yes"
        />
        <TaxFlowChartButton
          colClasses="col-xs-6 tax-flow-chart-button-col-right visible-xs"
          buttonClasses={`tax-flow-chart-button ${noButtonActive}`}
          onClick={() => props.setQBI(false)}
          text="No"
        />
      </div>
      <div className="row tax-flow-chart-answer-three-mobile visible-xs">
        <TaxFlowChartSectionThreeResult
          validQBI={props.validQBI}
          cdnURL={props.cdnURL}
          section={props.section}
          mobile
        />
      </div>
      <div className="row tax-flow-chart-answer-three row-eq-height hidden-xs">
        <TaxFlowChartSectionThreeResult
          validQBI={props.validQBI}
          iconSrc={props.iconSrc}
          cdnURL={props.cdnURL}
          section={props.section}
          top
        />
        <TaxFlowChartButton
          colClasses={`col-sm-2 ${yesButtonOffset} tax-flow-chart-pipe`}
          buttonClasses={`tax-flow-chart-button ${yesButtonActive}`}
          onClick={() => props.setQBI(true)}
          text="Yes"
        />
      </div>
      <div
        className={'row tax-flow-chart-answer-three tax-flow-chart-answer-three-no row-eq-height hidden-xs'}
      >
        <TaxFlowChartSectionThreeResult
          validQBI={props.validQBI}
          iconSrc={props.iconSrc}
          cdnURL={props.cdnURL}
          section={props.section}
        />
        <TaxFlowChartButton
          colClasses={`col-sm-2 ${noButtonOffset} tax-flow-chart-pipe`}
          buttonClasses={`tax-flow-chart-button ${noButtonActive}`}
          onClick={() => props.setQBI(false)}
          text="No"
        />
      </div>
    </React.Fragment>
  );
};

TaxFlowChartSectionThree.propTypes = {
  section: PropTypes.number.isRequired,
  validQBI: PropTypes.bool.isRequired,
  setQBI: PropTypes.func.isRequired,
  isSingle: PropTypes.bool.isRequired,
  iconSrc: PropTypes.string.isRequired,
  cdnURL: PropTypes.string.isRequired,
};

export default TaxFlowChartSectionThree;



// WEBPACK FOOTER //
// ./src-react/TaxFlowChart/components/TaxFlowChartSectionThree.jsx